import { render, staticRenderFns } from "./StoreEditor.vue?vue&type=template&id=06a8c262&scoped=true&"
import script from "./StoreEditor.vue?vue&type=script&lang=js&"
export * from "./StoreEditor.vue?vue&type=script&lang=js&"
import style0 from "./StoreEditor.vue?vue&type=style&index=0&id=06a8c262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a8c262",
  null
  
)

export default component.exports